<template>
  
    <v-container>
      <div class="mt-16">
      <v-row >
        <v-col cols="12" md="4">
          <v-card>
            <v-card-title>
              Add Appointment
            </v-card-title>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Title"
                  v-model="appointment.title"
                />
                <v-text-field
                  label="Description"
                  v-model="appointment.description"
                />
                <v-text-field
                  label="Date"
                  type="date"
                  v-model="appointment.date"
                />
                <v-btn @click="addAppointment">
                  Add
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="8">
          <v-calendar
            :events="events"
            @click:event="viewEvent"
          />
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            {{ selectedEvent.title }}
          </v-card-title>
          <v-card-text>
            {{ selectedEvent.description }}
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>
    </v-container>
  
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      appointment: {
        title: '',
        description: '',
        date: ''
      },
      events: [],
      dialog: false,
      selectedEvent: {}
    }
  },
  mounted() {
    this.fetchAppointments();
  },
  methods: {
    async fetchAppointments() {
      const appointments = await axios.get('api/appointments');
      this.events = appointments.data.map(appointment => ({
        title: appointment.title,
        description: appointment.description,
        start: new Date(appointment.date),
        end: new Date(appointment.date)
      }));
    },
    async addAppointment() {
      await axios.post('api/appointments', this.appointment);
      this.fetchAppointments();
    },
    viewEvent(event) {
      this.selectedEvent = event;
      this.dialog = true;
    }
  }
}
</script>
